export default "__VITE_PUBLIC_ASSET__34d3a016__"